module.exports = __webpack_public_path__ + "static/media/3-KNAIN.e46f547e.mp3";